var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageDark1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "storage-dark 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 97.29C76.1175 97.29 97.29 76.1175 97.29 50C97.29 23.8824 76.1175 2.70996 50 2.70996C23.8824 2.70996 2.70996 23.8824 2.70996 50C2.70996 76.1175 23.8824 97.29 50 97.29Z",
    fill: "#4B5450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.25 48.1202V78.9002H36.17V52.6302L37.84 50.9602L48.5 46.0502L32.39 37.9102L12.25 48.1202Z",
    fill: "#A3B7AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.38 47.05L32.33 39.21L12.25 49.68",
    stroke: "#7E8E86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1699 91.31H86.5099V51.89L61.3399 39L36.1699 51.89V91.31Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.2596 58.6504H43.5996V62.7304H52.2596V58.6504Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.1504 64H19.6504V79.39H36.1504V64Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M49.4004 4.66016C43.7604 4.66016 39.1904 9.23016 39.1904 14.8702C39.1904 20.5102 49.4004 40.4902 49.4004 40.4902C49.4004 40.4902 59.6104 20.5102 59.6104 14.8702C59.6104 9.23016 55.0404 4.66016 49.4004 4.66016ZM49.4004 20.5202C46.4104 20.5202 43.9804 18.0902 43.9804 15.1002C43.9804 12.1102 46.4104 9.68016 49.4004 9.68016C52.3904 9.68016 54.8204 12.1102 54.8204 15.1002C54.8204 18.0902 52.3904 20.5202 49.4004 20.5202Z",
    fill: "#00B76D",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M79.8296 57.9199H42.8496V91.3099H79.8296V57.9199Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.8496 85.7402H79.8296",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M42.8496 80.1797H79.8296",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M42.8496 74.6104H79.8296",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M42.8496 69.0498H79.8296",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M42.8496 63.4795H79.8296",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.0597 45.7303L32.3297 37.5303L8.38965 50.0103",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.3899 79.9597H12.4199V47.7197",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M36.1504 64H19.6504V79.96H36.1504V64Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M79.0598 64.25H61.3398V68.27H79.0598V64.25Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M79.0598 86.5H52.2598V90.54H79.0598V86.5Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M79.0598 75.3496H52.2598V79.3896H79.0598V75.3496Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M32.3898 49.1C34.0743 49.1 35.4398 47.7345 35.4398 46.05C35.4398 44.3655 34.0743 43 32.3898 43C30.7054 43 29.3398 44.3655 29.3398 46.05C29.3398 47.7345 30.7054 49.1 32.3898 49.1Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.4199 58.25H16.0999",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.6504 69.0498H35.4404",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M20 74.6104H35.79",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M12.4199 75.0996H16.0999",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M12.4199 60.9102H14.2599",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M91.6101 54.78L61.3401 39L31.0801 54.78",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M36.1699 51.8896V91.3096H86.5099V51.8896",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageDark1);
export default __webpack_public_path__ + "static/media/storage-dark1.a43d57a6f39c920cc2da4ff2bae14a82.svg";
export { ForwardRef as ReactComponent };